import React from "react";

/**
 * SectionLabel — unified eyebrow across ALL sections.
 * Same font (Manrope semibold), same size (17px desktop / 15px mobile),
 * same tracking (0.22em uppercase), same raspberry accent color.
 *
 * Usage:
 *   <SectionLabel number="03" text="I nostri servizi" />
 *   <SectionLabel text="Benvenuta" />
 *   <SectionLabel text="FAQ" tone="muted" />
 */
export default function SectionLabel({
    number,
    text,
    tone = "accent", // 'accent' | 'muted' | 'sage' | 'light'
    className = "",
}) {
    const color =
        tone === "muted"
            ? "text-ink-muted"
            : tone === "sage"
              ? "text-sage-deep"
              : tone === "light"
                ? "text-ivory/85"
                : "text-raspberry";

    return (
        <p
            data-testid="section-label"
            className={`inline-flex items-center gap-3 font-sans font-semibold text-[15px] md:text-[17px] uppercase tracking-[0.22em] ${color} ${className}`}
        >
            <span className="inline-block w-8 md:w-10 h-[2px] bg-current opacity-70" />
            {number && (
                <span className="tabular-nums font-medium opacity-90">
                    {number}
                </span>
            )}
            {number && (
                <span className="opacity-60" aria-hidden>
                    ·
                </span>
            )}
            <span>{text}</span>
        </p>
    );
}
